import { render } from "./DateGeneric.vue?vue&type=template&id=16947e24"
import script from "./DateGeneric.vue?vue&type=script&lang=ts"
export * from "./DateGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script